import {
  VariantAnalyticsInputSchema,
  VariantAnalyticsOutputSchema,
} from "@redotech/redo-model/analytics/returns-claims/variant-analytics";
import * as z from "zod";

export const getReturnAnalyticsByVariant = {
  name: "getReturnAnalyticsByVariant" as const,
  input: VariantAnalyticsInputSchema,
  output: VariantAnalyticsOutputSchema,
};

export type ReturnAnalyticsByVariant = z.infer<
  typeof getReturnAnalyticsByVariant.output
>;
